import { useState } from 'react';

import { config } from '@/config';

import { useManifestPoller } from './use-manifest-poller';
import { useNavigationReload } from './use-navigation-reload';

export function ManifestUpdate() {
    const [updatesPending, setUpdatesPending] = useState(false);
    const isEnabled = config.ENABLE_MANIFEST_POLLING;

    const handleUpdateDetected = () => {
        setUpdatesPending(true);
    };

    useManifestPoller(isEnabled ? handleUpdateDetected : undefined);
    useNavigationReload(isEnabled && updatesPending);

    return null;
}
